'use strict';
var has = require('../internals/map-helpers').has;

// Perform ? RequireInternalSlot(M, [[MapData]])
module.exports = function (it) {
  has(it);
  return it;
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/a-map.js
// module id = 70
// module chunks = 0